import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/BedspaceChangeReport/SearchReport",
    method: "get",
    params
  });
}
export function getColumns(params) {
  return request({
    url: "/BedspaceChangeReport/GetReportHeader",
    method: "get",
    params
  });
}
